export interface Filter {
    limit?: number;
    offset?: number;
    skip?: number;
    order?: string;
    where?: any;
    fields?: { [key: string]: boolean };
    include?: Array<any>;
}